import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import { useEffect, useState, useRef } from "react";

const AppUploadFile = (props) => {
  // console.log({ AppUploadFile: props });
  const inputRef = useRef(null);
  const [filevalue, setFilevalue] = useState(null);
  const [filename, setFilename] = useState("");
  const [fileobjvalue, setFileObjValue] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (uploadStatus !== "removed") {
      if (props.defaultValue instanceof Array) {
        setFilevalue(props.defaultValue[0]?.attachment_id);
      } else if (
        props.defaultValue === "" ||
        props.defaultValue === undefined
      ) {
        setFileList([]);
      } else {
        setFilevalue(props.defaultValue);
        setFileList([
          {
            uid: filevalue,
            name: "file.png",
            status: "done",
            url: `${props.apis.api().api_base}/api/v1/files/download/${
              props.defaultValue
            }`,
          },
        ]);
      }
    }
  }, [props.defaultValue]);

  const handleChange = (...args) => {
    let [info] = args;
    console.log("FILE: ", info.file);
    console.log("FILE NAME: ", info.file.name);
    console.log("FILE STATUS: ", info.file.status);

    setFileObjValue(info.file);
    setFilename(info.file.name);
    setUploadStatus(info.file.status);

    if (info.file.status === "done") {
      // setting uploaded filename
      let atag = document.querySelector(
        `[name="appinput-${props?.name}"] .ant-upload-list-item-name`
      );
      console.log(props?.name, atag);
      atag.title = info?.file?.name;
    }

    if (info.file.status === "uploading") {
      swal2.fire("Uploading file please wait....");

      let payload = {
        foldername: props.foldername,
      };

      let reqdata = {
        file: info.file.originFileObj,
      };

      console.log({ payload });

      props.apis
        .apiFileUploader(reqdata, payload)
        .then((res) => {
          console.log({ res });

          let attachmentId = res.file_id;
          setFilevalue(attachmentId);
          setFileList([
            {
              uid: attachmentId,
              name: info.file.name,
              status: "done",
              url: `${
                props.apis.api().api_base
              }/api/v1/files/download/${attachmentId}`,
            },
          ]);
          inputRef.current.invalue = attachmentId;
          // props.onFileUploaded && props.onFileUploaded(attachmentId);
          props.onChange && props.onChange(info.file);
          swal2.closeModal();
        })
        .catch((error) => {
          swal2.closeModal();
          swal2.fire({
            title: error?.message,
            timer: 3000,
          });
          console.log(error);
        });
    }

    if (info.file.status === "removed") {
      console.log({ filevalue });

      swal2.fire({
        title: "Deleting file please wait....",
      });
      const handleRemove = () => {
        swal2.closeModal();
        inputRef.current.invalue = "";
        setFilename("");
        setFilevalue("");
        setFileList([]);
        props.onChange && props.onChange("");
      };
      props.apis
        .apiFileRemover({ fileId: filevalue })
        .then(handleRemove)
        .catch(handleRemove);
    }
  };

  let { multiple = false, maxCount = 1 } = props;

  const attrs = {
    ...Object.except(props, ["className", "name", "onChange"]),
    onChange: handleChange,
    multiple,
    maxCount,
  };

  props.$setNode({
    props,
  });

  return (
    <Upload
      {...attrs}
      customRequest={({ onSuccess }) => onSuccess("ok")}
      fileList={fileList}
    >
      <input
        ref={inputRef}
        type="hidden"
        className="filevalue_container"
        name={props.name}
        {...(props.accept ? { accept: props.accept } : {})}
        filename={filename}
        value={filevalue}
      ></input>
      <Button icon={<UploadOutlined />}>
        {props?.fileLabel || "Upload File"}
      </Button>
      {/* <div className="text-end ml-auto">(jpg, doc, pdf)</div> */}
    </Upload>
  );
};
export default constore(AppUploadFile);
